import {
    FEATURES_TAB_REQUEST,
    FEATURES_TAB_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    result: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case FEATURES_TAB_REQUEST:
            return { ...state, loading: true }

        case FEATURES_TAB_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "FEATURE_TAB"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};